import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ParameterService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	getParameters(token) {

		return this.http
		.get(this.apiUrl + "system/v1/getparameters?$orderby=Grupo,Ordem,Tipo,Chave", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	insertParameter(token, data: any) {









		return this.http
		.put(this.apiUrl + "system/v1/updatelistparameters", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
			return Observable.throw('Unauthorized');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/parameters/service/parameters/parameters.service.ts